import { render, staticRenderFns } from "./wsqLeft.vue?vue&type=template&id=87b1ab6e&scoped=true&"
import script from "./wsqLeft.vue?vue&type=script&lang=js&"
export * from "./wsqLeft.vue?vue&type=script&lang=js&"
import style0 from "./wsqLeft.vue?vue&type=style&index=0&id=87b1ab6e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "87b1ab6e",
  null
  
)

export default component.exports